import { connect } from 'react-redux';
import { redux } from '../api';

import IntelligentScreening from './IntelligentScreening.js';
// import { redux as apiRedux } from '../api';

const { setApplicationInfo, setCurrentSearchInfo } = redux.actions;

const mapStateToProps = state => {
  return {
    user: state.api.user,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setApplicationData: data => {
      dispatch(setApplicationInfo(data));
    },
    setCurrentSearchInfoData: data => {
      dispatch(setCurrentSearchInfo(data));
    },
  };
};

const ConnectedIntelligentScreening = connect(
  mapStateToProps,
  mapDispatchToProps
)(IntelligentScreening);

export default ConnectedIntelligentScreening;
